import './assets/main.scss'

import {createApp, ref} from 'vue'
import {createPinia} from 'pinia'
import App from './App.vue'
import router from './router'
// import { init as initFullStory, FullStory } from '@fullstory/browser'
import {datadogRum} from '@datadog/browser-rum'

import {createGtm} from '@gtm-support/vue-gtm'
import {useUserStore} from '@/stores/UserStore'
import type {User} from '@/types/User'
import {useOrganizationStore} from '@/stores/OrganizationStore'

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.mount('#app')

const userStore = useUserStore()
const organizationStore = useOrganizationStore()

// Show a message flashed by a server redirect (e.g. a failed guest claim link)
// on the login page, which is where signed-out redirects land.
if (window.__APP_CONFIG__?.flashMessage) {
  userStore.authenticationErrorMessage = window.__APP_CONFIG__.flashMessage
}
const user = ref(null as User | null)

userStore.fetchUser().finally(() => {
    user.value = userStore.currentUser
    organizationStore.applyTheme()
})

/**
 * Session Replay
 */
datadogRum.init({
    applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
    clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.com',
     service: 'sensory',
    //  env: 'production',
    //  version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
})

if (user.value) {
    datadogRum.setUser({
        id: (user.value?.id ?? user.value?.email).toString(),
        name: user.value?.firstName + ' ' + user.value?.lastName,
        email: user.value?.email,
    })
}

/**
 * Google Tag Manager (GTM)
 */
// createGtm throws without a valid id, which would crash the app mount (e.g. local dev).
if (import.meta.env.VITE_GTM_ID) {
    app.use(
        createGtm({
            id: import.meta.env.VITE_GTM_ID,
            vueRouter: router
        })
    )
}
